import { render, staticRenderFns } from "./UserCustomers.vue?vue&type=template&id=ae2f9580&scoped=true&"
import script from "./UserCustomers.vue?vue&type=script&lang=js&"
export * from "./UserCustomers.vue?vue&type=script&lang=js&"
import style0 from "./UserCustomers.vue?vue&type=style&index=0&id=ae2f9580&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2f9580",
  null
  
)

export default component.exports